export function FieldError({ error }) {
  if (!error) return null;
  return (
    <p className="mt-1 text-xs text-red-600 dark:text-red-400" data-testid="field-error-text">
      {error}
    </p>
  );
}
